
namespace Matrix.Workflow {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class ColorFormatter implements Serenity.ISlickFormatter {
        format(ctx: Slick.FormatterContext) {
            return ColorFormatter.formatValue(ctx.value);
        }

        public static formatValue(value: number) {
            if (value == null)
                return "";

            return `<i style="display: inline-block; width: 16px; height: 14px; position: relative; top: 2px; border: 1px solid #000; background-color: ${Q.attrEncode(value)}"></i> ${Q.htmlEncode(value)}`;
        }
    }
}